import React from 'react';
import { Box, Alert } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Error } from '@mui/icons-material';
import { KyronTooltip } from './KyronTooltip';

const StyledDiv = styled(Box)(() => ({
  maxWidth: 500,
}));

export function ErrorIndicator({ error }: { error: Error | null }) {
  if (!error) return null;
  return (
    <Box display='flex' justifyContent='center' alignItems='center' data-testid='error-indicator'>
      <KyronTooltip
        components={{ Tooltip: StyledDiv }}
        title={<Alert severity='error'>{error.message}</Alert>}
        inactive={!error.message}
      >
        <Error color='error' />
      </KyronTooltip>
    </Box>
  );
}
